/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export interface Policereport {
  /** @nullable */
  investigatingOfficer?: string;
  /** @minLength 1 */
  policeDetachment: string;
  /** @nullable */
  policeDetachmentOther?: string;
  /** @nullable */
  policeFileNumber?: string;
  /** @nullable */
  policeReportedMultipleTimes?: string;
  /** @nullable */
  reportEndDate?: string;
  /** @nullable */
  reportStartDate?: string;
}
